'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../../_tslib-15827112.js');
var BaseController = require('../BaseController.js');

var CashbackRewardsController = /** @class */ (function (_super) {
    _tslib.__extends(CashbackRewardsController, _super);
    function CashbackRewardsController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CashbackRewardsController.prototype.GetActive = function () {
        return _tslib.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return _tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/CashbackRewards/Active/" + this.config.countryCode;
                        return [4 /*yield*/, this.MakeRequest({
                                url: url,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.ensureValidRewards(response)];
                }
            });
        });
    };
    CashbackRewardsController.prototype.Submit = function (rewardId, promoCouponId, data) {
        var url = "/CashbackRewards/" + this.config.countryCode;
        return this.MakeRequest({
            method: "POST",
            url: url,
            data: {
                rewardId: rewardId,
                data: _tslib.__assign(_tslib.__assign({}, data), { promoCouponId: promoCouponId })
            }
        });
    };
    /**
     * Takes an array of rewards, and returns a modified discarding all misconfigured rewards.
     */
    CashbackRewardsController.prototype.ensureValidRewards = function (rewards) {
        var _this = this;
        if (!rewards) {
            return [];
        }
        return rewards
            .map(function (reward) {
            if (!_this.ensureRequiredValues(reward)) {
                return null;
            }
            switch (reward.subType) {
                case "SURVEY":
                    return _this.ensureSurvey(reward);
                case "EXTERNAL_URL":
                    return reward;
                default:
                    return null;
            }
        })
            .filter(function (r) { return Boolean(r); });
    };
    /**
     * Validates a Survey. If it is not valid, it returns `null`;
     */
    CashbackRewardsController.prototype.ensureSurvey = function (survey) {
        var _a, _b, _c;
        if (!((_b = (_a = survey.data) === null || _a === void 0 ? void 0 : _a.Questions) === null || _b === void 0 ? void 0 : _b.length)) {
            // Survey without questions. Not Valid.
            return null;
        }
        for (var _i = 0, _d = survey.data.Questions; _i < _d.length; _i++) {
            var question = _d[_i];
            if (["RADIO", "CHECKBOX"].includes(question.Type)) {
                if (!((_c = question.Options) === null || _c === void 0 ? void 0 : _c.length)) {
                    // Radio or checkbox question without options is not valid
                    return null;
                }
            }
            if (question.Type === "CHECKBOX") {
                if (!Array.isArray(question.Default)) {
                    // Checkbox questions must provide an array of defaults
                    return null;
                }
            }
        }
        return survey;
    };
    CashbackRewardsController.prototype.ensureRequiredValues = function (reward) {
        var requiredFields = ["Title", "Subtitle", "Subtitle_Completed", "ButtonLabel"];
        var values = Object.entries(reward.data);
        var _loop_1 = function (field) {
            var value = values.find(function (_a) {
                var key = _a[0];
                return key === field;
            });
            if (!Boolean(value)) {
                console.error("Reward " + reward.id + " is missing the following field: " + field);
                return { value: false };
            }
        };
        for (var _i = 0, requiredFields_1 = requiredFields; _i < requiredFields_1.length; _i++) {
            var field = requiredFields_1[_i];
            var state_1 = _loop_1(field);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return true;
    };
    return CashbackRewardsController;
}(BaseController.default));

exports.default = CashbackRewardsController;
//# sourceMappingURL=CashbackRewardsController.js.map
